module.exports = __webpack_public_path__ + "static/media/dailyIcon3.fabf93e0.svg";